export default "__VITE_ASSET__74c6467a__"